/* eslint-disable react-hooks/rules-of-hooks */
import { CHARACTERISTICS_TO_EXTRACT, ESTATE_ATTRIBUTES, extractCharacteristics } from '@contexts/Shared/utils/estate';
import { useTranslations } from 'next-intl';
import { formatMoney } from '../utils/format-money';
import { PAGE_CATEGORY } from './url';

export enum pageCategory {
  HOME = 'HOME',
  RESULT_PAGE = 'RESULT_PAGE',
  DETAILS_PAGE = 'DETAILS_PAGE',
  RECOMMENDATIONS_PAGE = 'RECOMMENDATIONS_PAGE',
}

function home(t) {
  return {
    title: t('homeSeoTitle'),
    description: t('homeSeoDescription'),
    h1: t('homeSeoH1'),
    canonical: t('homeSeoCanonical'),
    image: `https://www.${process.env.NEXT_PUBLIC_URL_APTUNO}/images/aptuno_logo.png`,
  };
}

function resultPage(
  t,
  { propertyType = null, location = 'Bogotá', locationAvgPrice = 2000000, propertiesCount = 0, currentViewCount = 0 }
) {
  const propertyTypeCapitalized = getPropertyTypeTextCapitalized(propertyType);
  const propertyTypeLowerCase = propertyTypeCapitalized.toLowerCase();
  return {
    title: t('searchResultSeoTitle', { propertyTypeCapitalized, location }),
    description: t('searchResultSeoDescription', { propertiesCount, propertyTypeLowerCase, location }),
  };
}

function getPropertyTypeTextCapitalized(propertyType) {
  const glossaryT = useTranslations('glossary');
  switch (propertyType) {
    case 'APARTMENT':
      return glossaryT('apartmentUpcase');
    case 'HOUSE':
      return `Casa`;
  }
  return `Inmueble`;
}

export function detailPage(
  t,
  { characteristics: rawCharacteristics, media, location, price, administrationPrice, propertyType, title }
) {
  const propertyTypeCapitalized = getPropertyTypeTextCapitalized(propertyType);
  const adminPrice = administrationPrice || 0;
  const formattedPrice = formatMoney(Number(price) + Number(adminPrice));
  const characteristics = extractCharacteristics(rawCharacteristics || [], CHARACTERISTICS_TO_EXTRACT);
  const bedrooms = characteristics[ESTATE_ATTRIBUTES.BEDROOMS];
  const area = characteristics[ESTATE_ATTRIBUTES.AREA];
  const bedroomsText = bedrooms === 1 ? 'habitacion' : 'habitaciones';

  return {
    title: t('detailPageSeoTitle', { location: location.name, propertyTypeCapitalized, title, formattedPrice }),
    description: t('detailPageSeoDescription', {
      bedrooms,
      bedroomsText,
      area,
      formattedPrice,
      title,
      location: location.name,
      propertyTypeCapitalized,
    }),
    h1: t('detailPageSeoH1', { propertyTypeCapitalized, bedrooms, bedroomsText, area, formattedPrice }),
    image: media && media[0] ? media[0].uri.replace('.jpg', '_thumb.jpg') : '/images/aptuno_logo_2colors.svg',
    altImage: t('altImageSeo', { propertyTypeCapitalized, location: location.name, area, formattedPrice }),
    titleImage: t('titleImageSeo', { propertyTypeCapitalized, location: location.name }),
  };
}

function recommendationsPage(t, params) {
  return {
    title: t('recommendationsSeoTitle'),
  };
}

function getSeoForPage(translate, page = pageCategory.HOME, pageParams) {
  switch (page) {
    case pageCategory.RESULT_PAGE:
      return resultPage(translate, pageParams);
    case pageCategory.DETAILS_PAGE:
      return detailPage(translate, pageParams);
    case pageCategory.RECOMMENDATIONS_PAGE:
      return recommendationsPage(translate, pageParams);
    default:
      return home(translate);
  }
}

export { PAGE_CATEGORY, getSeoForPage };
